import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-in-group-buy-order-header',
  templateUrl: './in-group-buy-order-header.component.html',
  styleUrls: ['./in-group-buy-order-header.component.scss']
})
export class InGroupBuyOrderHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
